<template>
	<div class="panel_sale">
		<div class="list" v-if="type==='list'">
			<ximeiList></ximeiList>
		</div>
		<div class="add" v-if="type==='add'">
			<ximeiAdd ></ximeiAdd>
			<div class="settlementBox">
				<ximeiSettlement></ximeiSettlement>
			</div>
		</div>
	</div>
</template>
<script>
	import ximeiAdd from "./comp/ximei_add.vue"
	import ximeiList from "./comp/ximei_list.vue"
	import ximeiSettlement from "./comp/ximei_settlement.vue"
	export default {
		
		components:{ximeiAdd,ximeiList,ximeiSettlement},
		data(){
			return{
				
			}
		},
		computed:{
			type(){
				return this.$store.state.ximei.type;
			}
		},
		mounted(){
			
		},
		methods: {
			
		},
	}
</script>
<style scoped lang="scss">
.panel_sale{
	position: relative;
	width:100%;
	height: 100%;
	background-color: #fff;
	.settlementBox{
		position: absolute;
		bottom:0;
		width:100%;
	}
	.list{
		height: 100%;
	}
	.add{
		height: 100%;
	}
}
</style>
